// pages/ForgotPasswordPage.js
import React, { useState, useEffect } from "react";
import Subbanner from "../components/banner/subbanner";
import Forgetpas from "../components/auth/forgetpas";
import NewPassword from "../components/auth/newpassword";
import { DecodeTokenAuth } from "../lib/token";
const ForgotPasswordPage = () => {
  const [state, setState] = useState("");
  const obj = {
    page: "Forgot Password",
    title: "Forgot Password",
    background: "",
  };

  useEffect(() => {
    const url = new URL(window.location.href);
    const token = url.search.substring(1);
    const getid = DecodeTokenAuth(token);
    setState(getid);
  }, []);
  console.log("state", state);
  return (
    <>
      <Subbanner obj={obj} />
      {state?.id ? <NewPassword /> : <Forgetpas />}
    </>
  );
};

export default ForgotPasswordPage;
